<template>
	<span>
		<FullCalendar
			:events="lunchOptions"
			defaultView="dayGridMonth"
			:weekends="calendarWeekends"
			:plugins="calendarPlugins"
			ref="calendar"
			:datesRender="loadLunchMenus"
			:eventRender="updateEvents"
			:locale="getSelectedLocale.LOCALE_CODE !== 'sa-us' ? getSelectedLocale.LOCALE_CODE : 'en-US'"
			:buttonText="{ today: $t( 'MAIN_CONTENT.StudentCalendar.today' ) }"
			@dateClick="handleDateClick"
		>
		</FullCalendar>
		<modal :modal-title="$t('MAIN_CONTENT.Calendar.lunchMenuModalTitle', { date: selectedDay, school: selectedSchool.SCHOOL_TITLE })"
					 :show="showLunchMenuModal"
					 dialog-size="md"
					 name="lunchMenu"
					 fields=""
					 @close="closeLunchMenuModal()">
			<p v-for="(lunch, lunchIndex) in selectedDayLunchOptions"
				 :key="`lunchModal_${lunchIndex}`"
				 v-html="formatText(lunch.LUNCH_MENU)">
			</p>
			<template slot="footer" :close="closeLunchMenuModal">
				<button type="button" class="btn btn-default" @click="closeLunchMenuModal">
					{{ $t( 'MAIN_CONTENT.commonContent.closeButton' ) }}
				</button>
			</template>
		</modal>
	</span>
</template>

<script>
	import Lunches from '../../api/Lunches';

	import Modal from 'COMMONS/shared/Modal/Modal.vue';

	import moment from 'moment';

	/* FullCalendar has a locale attribute that can be applied to convert everything to the required format so locale text
	** is unnecessary. https://fullcalendar.io/docs/locale
	*/
	import FullCalendar from '@fullcalendar/vue';
	import dayGridPlugin from '@fullcalendar/daygrid';
	import timeGridPlugin from '@fullcalendar/timegrid';
	import interactionPlugin from '@fullcalendar/interaction';

	import es from "@fullcalendar/core/locales/es";

	import "@fullcalendar/core/main.css";
	import "@fullcalendar/daygrid/main.css";
	import "@fullcalendar/timegrid/main.css";
	import { mapGetters } from 'vuex';

	export default {
		props: {
			selectedSchool: {
				type:			Object,
				default:	function() {
					return {
						'GRADE_LEVEL':	'',
						'SCHOOL_TITLE': '',
						'SCHOOL_YEAR':	'',
						'SCHOOL_ID':		''
					};
				}
			}
		},
		data() {
			return {
				lunchOptions: [],
				selectedDayLunchOptions: [],
				selectedDay: '',
				calendarPlugins: [	// plugins must be defined in the JS
					dayGridPlugin,
					timeGridPlugin,
					interactionPlugin // needed for dateClick
				],
				calendarWeekends: false,
				showLunchMenuModal: false,
				previousActiveElement : null,
			};
		},
		computed: {
			...mapGetters([ 'getSelectedLocale' ])
		},
		components: {
			FullCalendar,
			Modal
		},
		methods: {
			updateEvents(info) {
				info.el.tabIndex = 0;
				info.el.setAttribute('aria-label', `${info.event.start} ${info.event.title}`);

				info.el.setAttribute('role', 'button');
				info.el.setAttribute('aria-haspopup', 'dialog');
				
				const lunchDate = info.event.extendedProps.LUNCH_DATE;
				const dateStr = moment(lunchDate).format('YYYY-MM-DD');
				
				const open = (event) => {
					this.previousActiveElement = `${info.event.start} ${info.event.title}`;
					event.preventDefault();          // stop Space from scrolling the page
					this.handleDateClick({dateStr: dateStr, lunchDate: lunchDate});
				};

				// Mouse parity: clicking the event opens the same dialog.
				info.el.addEventListener('click', open);

				// Keyboard: Enter or Space opens the dialog.
				info.el.addEventListener('keydown', (event) => {
					if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
						open(event);
					}
				});
			},
			loadLunchMenus() {
				const self = this;

				let start = moment(
					self.$refs.calendar.$options.calendar.view.currentStart
				).startOf( "month" ).format( "MM/DD/YYYY" );

				let end = moment(
					self.$refs.calendar.$options.calendar.view.currentStart
				).endOf( "month" ).format( "MM/DD/YYYY" );

				let lunches = new Lunches({
					query: {
						school_id:	self.selectedSchool.SCHOOL_ID,
						start_date:	start,
						end_date:		end
					}
				});

				const promise = lunches.get();

				promise.then( response => {
					let data = JSON.parse( JSON.stringify( response.data.data ) );

					for( let i in data ) {
						data[ i ].title = data[ i ].LUNCH_MENU;
						data[ i ].start = moment( data[ i ].LUNCH_DATE ).format( 'YYYY-MM-DD' );
						data[ i ].end = moment( data[ i ].LUNCH_DATE ).format( 'YYYY-MM-DD' );
					}

					self.$set(self, 'lunchOptions', data);
				});
			},
			handleDateClick(day) {
				this.selectedDayLunchOptions = this.setSelectedLunchOptions(day.dateStr);
				if(this.selectedDayLunchOptions.length > 0) {
					this.showLunchMenuModal = true;
				}
			},
			setSelectedLunchOptions(selectedDay) {
				let options = [];

				for(let l in this.lunchOptions) {
					let option = this.lunchOptions[l];

					if(moment(option.LUNCH_DATE).format('YYYY-MM-DD') === selectedDay) {
						options.push(option);
					}
				}

				this.selectedDay = moment(selectedDay).format('ddd ll');

				return options;
			},
			closeLunchMenuModal() {
				this.showLunchMenuModal = false;
				this.selectedDay = '';
				this.selectedDayLunchOptions = [];
				this.$nextTick(() => {
					const el = [...document.querySelectorAll('[aria-haspopup=dialog]')]
						.find(e => e.getAttribute('aria-label') === this.previousActiveElement);
					if (el) el.focus();
				});
			},
			formatText(text) {
				return text.replace(/\n/g, '<br />');
			}
		},
		mounted() {
			this.loadLunchMenus();
		}
	}
</script>
